import './vendor';

import "./pages/index";
import "./pages/materials";
import "./pages/themes";
import "./pages/one-theme";
import "./pages/text-page"
import "./pages/one-exponat";
import "./pages/page-video";
import "./pages/notice";
import "./pages/search-page";
import "./pages/longrid";
import "./pages/game-index";
import "./pages/game-one";
import "./pages/game-one-images";
import "./pages/game-result";
import "./pages/game-puzzle";
import "./pages/game-loto";
import "./pages/lecture-cycle";
import "./pages/modal-excursion";


// WEBPACK FOOTER //
// ./src/js/main.js